/**
 * Spotlight produits (sections/shape-spotlight.liquid) : apparition au défilement et halo qui suit la souris.
 */
(() => {
  const sections = document.querySelectorAll('.spotlight');
  if (!sections.length) return;

  // Apparition des cartes au défilement
  document.documentElement.classList.add('spotlight-ready');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15 }
  );
  sections.forEach((section) => section.querySelectorAll('.spotlight__item').forEach((item) => observer.observe(item)));

  // Halo qui suit la souris
  document.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse') return;
    const card = event.target instanceof Element ? event.target.closest('.spot-card') : null;
    if (!(card instanceof HTMLElement)) return;
    const rect = card.getBoundingClientRect();
    card.style.setProperty('--mx', `${event.clientX - rect.left}px`);
    card.style.setProperty('--my', `${event.clientY - rect.top}px`);
  });
})();
